import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function getMe() {
  const r = await api.get("/auth/me");
  return r.data;
}

export async function exchangeSession(session_id) {
  const r = await api.post("/auth/session", { session_id });
  return r.data;
}

export async function logout() {
  const r = await api.post("/auth/logout");
  return r.data;
}

export async function getPreferences() {
  const r = await api.get("/preferences");
  return r.data;
}

export async function updatePreferences(updates) {
  const r = await api.put("/preferences", updates);
  return r.data;
}

export async function getHistory() {
  const r = await api.get("/history");
  return r.data;
}

export async function addHistory(item) {
  const r = await api.post("/history", item);
  return r.data;
}

export async function deleteHistory(id) {
  const r = await api.delete(`/history/${id}`);
  return r.data;
}

export async function clearHistory() {
  const r = await api.delete(`/history`);
  return r.data;
}
